import { render } from "./AlzataAdminLayout.vue?vue&type=template&id=0fecfa4b"
import script from "./AlzataAdminLayout.vue?vue&type=script&lang=js"
export * from "./AlzataAdminLayout.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__